import _ from 'lodash';

export default function getPostCover(contentState = {}) {
  const entities = contentState.entityMap || {};
  const key = _.findKey(entities, entity => entity.type === 'IMAGE');
  const entity = entities[key];

  return entity ? entity.data.src : null;
}

export function getPostVideoEmbedCover(contentState = {}) {
  const entities = contentState.entityMap || {};
  const key = _.findKey(entities, entity => entity.type === 'VIDEO-EMBED');
  const entity = entities[key];

  return entity ? entity.data.oembed : null;
}



// WEBPACK FOOTER //
// ./app/services/get-post-cover.js